import React, {useState} from 'react';
import styled from "styled-components";
import {Button, Icon, Modal} from "react-materialize";
import ActionLink from "./ActionLink.react";
import {useHistory} from "react-router";

const StyledConciliateModal = styled(Modal)`
  width: 40rem;
  
  .modal-content {
    padding: 0;
    margin-top: 0;
  }
  
  .header {
    display: flex;
    align-items: center;
    height: 8rem;
    background: linear-gradient(135deg,#0f82c5,#07bb9c);
    color: white;
    padding: 1rem;
    
    h4 {
      font-size: 3rem;
      margin-left: auto;
      margin-right: auto;
    }
    
    i {
      font-size: 3rem;
      position: absolute;
      right: 0;
      margin-right: 1rem;
      cursor: pointer;
    }
  }
  
  .transaction-action-list {
    display: flex;
    flex-direction: column;
    
    .action-link {
      height: 8rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 2rem;
      padding-right: 1rem;
      color: #B6B6B6;
      
      p {
        font-size: 2.5rem;
      }
      
      i {
        font-size: 3.5rem;
      }
      
      :hover {
        cursor: pointer;
        color: #0288BD;
      }
    }
  }
`

const ConciliateTransactionsModal = ({open = false, handleToggle}) => {
  const [modalState, setModalState] = useState('INITIAL');
  const history = useHistory();

  const handleClose = () => {
    handleToggle(false);
  }

  const handleClick = (value) => {
    if (value === 'RECONCILE') {
      handleClose();
      history.push(`/reconcile-transactions`)
    } else {
      setModalState(value);
    }
  }

  return (
    <StyledConciliateModal
      open={open}
      options={{
        onCloseEnd: () => handleClose()
      }}
      actions={[]}
    >
      <div className={'header'}>
        <h4>Add Transactions</h4>
        <Icon onClick={() => handleClose()}>close</Icon>
      </div>
      <div className={'transaction-action-list'}>
        <ActionLink value={'LINK_EXCHANGE'} label={'Link Exchange'} handleClick={handleClick} />
        <ActionLink value={'IMPORT_CSV'} label={'Import CSV'} handleClick={handleClick} />
        <ActionLink value={'ADD_TRANSACTION'} label={'Manual Add'} handleClick={handleClick} />
        <ActionLink value={'RECONCILE'} label={'Reconcile Transactions'} handleClick={handleClick} />
      </div>
    </StyledConciliateModal>
  )
}

export default ConciliateTransactionsModal;